import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
} from 'react';

type AppointmentInfo = {
  prescription_was_send: boolean;
};

type PrescriptionContextType = {
  wasPrescriptionSent: boolean;
  setWasPrescriptionSent: (value: boolean) => void;
};

const PrescriptionContext = createContext<PrescriptionContextType | undefined>(undefined);

export const PrescriptionProvider = ({ children, initialWasPrescriptionSent }: { children: ReactNode; initialWasPrescriptionSent: boolean }) => {
  const [wasPrescriptionSent, setWasPrescriptionSent] = useState(initialWasPrescriptionSent);

  return (
    <PrescriptionContext.Provider value={{ wasPrescriptionSent, setWasPrescriptionSent }}>
      {children}
    </PrescriptionContext.Provider>
  );
};


export const usePrescriptionContext = () => {
  const context = useContext(PrescriptionContext);
  if (!context) {
    throw new Error('usePrescriptionContext must be used within a PrescriptionProvider');
  }
  return context;
};
